module.exports = "/assets/ecs/lno/ecs-lno-frontend-concierge/3.6.2/_next/static/images/post-participar-lno-d927b3bae9641026a38e31be78bddbad.png";